// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".defaultLayoutContent[data-v-44caf000]{min-height:100vh}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
